import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/lib/i18n";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Inbox from "@/pages/Inbox";
import Fans from "@/pages/Fans";
import Vault from "@/pages/Vault";
import AISettings from "@/pages/AISettings";
import Connections from "@/pages/Connections";
import Settings from "@/pages/Settings";
import MassMessage from "@/pages/MassMessage";
import Pricing from "@/pages/Pricing";

function Protected({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "rgb(18,20,28)",
                border: "1px solid rgba(255,255,255,0.08)",
                color: "white",
                borderRadius: 0,
                fontFamily: "Outfit, sans-serif",
              },
            }}
          />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/inbox" element={<Protected><Inbox /></Protected>} />
            <Route path="/fans" element={<Protected><Fans /></Protected>} />
            <Route path="/vault" element={<Protected><Vault /></Protected>} />
            <Route path="/ai" element={<Protected><AISettings /></Protected>} />
            <Route path="/mass" element={<Protected><MassMessage /></Protected>} />
            <Route path="/connections" element={<Protected><Connections /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />

            <Route path="/pricing" element={<Protected><Pricing /></Protected>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
